import React from "react";
import { createRoot } from "react-dom/client";
import HomePage from "./HomePage";

declare global {
	interface Window {
		renderDataStoreHomePage: unknown;
	}
}

export function renderDataStoreHomePage(rootId: string) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(<HomePage />);
}

window.renderDataStoreHomePage = renderDataStoreHomePage;
